module.exports = __webpack_public_path__ + "resource/img/a3.f6dc73f2.jpg";